import * as actionTypes from "../actionTypes/authTypes";
import axios from "../../axios-instance";
import ROUTES from "../../constants/routes";

const registrationStart = () => ({ type: actionTypes.REGISTRATION_START });
const registrationSuccess = (user) => ({
  type: actionTypes.REGISTRATION_SUCCESS,
  payload: user,
});
const registrationFail = (error) => ({
  type: actionTypes.REGISTRATION_FAIL,
  error,
});

const signInStart = () => ({ type: actionTypes.SIGN_IN_START });
const signInSuccess = (user) => ({
  type: actionTypes.SIGN_IN_SUCCESS,
  payload: user,
});
const signInFail = (error) => ({ type: actionTypes.SIGN_IN_FAIL, error });

const logoutStart = (error) => ({ type: actionTypes.LOGOUT_START, error });
const logoutSuccess = (user) => ({ type: actionTypes.LOGOUT_SUCCESS });
const logoutFail = (error) => ({ type: actionTypes.LOGOUT_FAIL, error });

const refreshTokenStart = () => ({ type: actionTypes.REFRESH_TOKEN_START });
const refreshTokenSuccess = (user) => ({
  type: actionTypes.REFRESH_TOKEN_SUCCESS,
  user,
});
const refreshTokenFail = (error) => ({
  type: actionTypes.REFRESH_TOKEN_FAIL,
  error,
});

const changePasswordRequestStart = () => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_START,
});
const changePasswordRequestSuccess = () => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_SUCCESS,
});
const changePasswordRequestFail = (error) => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST_FAIL,
  error,
});

const changePasswordStart = () => ({ type: actionTypes.CHANGE_PASSWORD_START });
const changePasswordSuccess = () => ({
  type: actionTypes.CHANGE_PASSWORD_SUCCESS,
});
const changePasswordFail = (error) => ({
  type: actionTypes.CHANGE_PASSWORD_FAIL,
  error,
});

const getHeaders = () => ({
  "Content-Type": "application/json-patch+json",
  Accept: "text/plain",
});

export const register = (data) => (dispatch) => {
  dispatch(registrationStart());
  return axios
    .post("/Authorization/RegisterPromoter", data, { headers: getHeaders() })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(registrationSuccess(result));
      return result;
    })
    .catch((err) => {
      dispatch(registrationFail(err));
    });
};

export const signIn = (data) => (dispatch) => {
  dispatch(signInStart());
  return axios
    .post("/Authorization/LoginPromoter", data, { headers: getHeaders() })
    .then((response) => {
      if (response.data.isSuccess) {
        return response.data.result;
      }
      throw new Error(response.data.errorMessage);
    })
    .then((result) => {
      dispatch(signInSuccess(result));
      localStorage.setItem("user", JSON.stringify(result));
      return result;
    })
    .catch((err) => {
      localStorage.setItem("bufferEmail", data.email);
      if (err.response) {
        if (err.response.data.Email && err.response.data.Password) {
          dispatch(signInFail(`The Email and Password fields are required`));
        }
        if (err.response.data.Password) {
          dispatch(signInFail(err.response.data.Password[0]));
        }
        if (err.response.data.Email) {
          dispatch(signInFail(err.response.data.Email[0]));
        }
      } else {
        dispatch(signInFail(err.message));
      }
    });
};

export const refreshToken = (data) => (dispatch) => {
  dispatch(refreshTokenStart());
  return axios
    .post("/Authorization/RefreshToken", data)
    .then((response) => {
      if (response.data.message || response.data.code === 4007) {
        throw response;
      }
      return response.data.result;
    })
    .then((result) => {
      const newUserData = {
        ...JSON.parse(localStorage.getItem("user")),
        ...result,
      };
      localStorage.setItem("user", JSON.stringify(newUserData));
      dispatch(refreshTokenSuccess(newUserData));
    })
    .catch((err) => {
      dispatch(refreshTokenFail(err));

      if (err.data && err.data.code === 4007) {
        window.location.href = ROUTES.LOGIN;
        localStorage.setItem("isBlocked", true);
      }
    });
};

export const changePasswordRequest = (data) => (dispatch) => {
  dispatch(changePasswordRequestStart());
  return axios
    .put("/Users/ForgotPassword", data, { headers: getHeaders() })
    .then((response) => {
      dispatch(changePasswordRequestSuccess(response));
      return response;
    })
    .catch((err) => {
      dispatch(changePasswordRequestFail(err));
    });
};

export const changePassword = (data) => (dispatch) => {
  dispatch(changePasswordStart());
  return axios
    .put("/Users/ResetPassword", data, { headers: getHeaders() })
    .then((response) => {
      dispatch(changePasswordSuccess(response));
      return response;
    })
    .catch((err) => {
      dispatch(changePasswordFail(err));
    });
};

export const logout = (err) => (dispatch) => {
  if (
    localStorage.getItem("userCopy") &&
    window.location.pathname !== ROUTES.PROMOTERS
  ) {
    localStorage.setItem("user", localStorage.getItem("userCopy"));
    localStorage.removeItem("userCopy");
    window.location.href = "/promoters";
  } else {
    localStorage.removeItem("user");
    localStorage.removeItem("userCopy");
    dispatch(logoutStart(err));
  }
};

const resetErrorStart = () => ({ type: actionTypes.RESET_ERROR });

export const resetError = () => (dispatch) => {
  dispatch(resetErrorStart());
};
